module.exports = "static/assets/6cd3397308e11e6d925446470b906f2a.woff2";